import { httpClient } from "@services/api/httpClient";

const eligibleForTechnicalAssessment = async (applicantId: number) => {
    
        const response = await httpClient.get("/offer-applicant/eligible-for-technical-assessment", {
            params: {
                applicantId
            }
        });
        return response.data;
};

export default eligibleForTechnicalAssessment;